import { h } from "preact";
import logo from "../assets/images/logos/humanitix.svg";

const PoweredByHumanitix = () => {
  return (
    <div
      style={{
        fontWeight: 300,
        padding: "0 12px 12px 12px",
        display: "flex",
        justifyContent: "flex-end"
      }}
    >
      <p
        style={{
          fontSize: 10,
          margin: 0,
          color: "#5A626C"
        }}
      >
        Powered by
      </p>{" "}
      <img
        src={logo}
        alt="Humanitix"
        style={{
          height: 15,
          marginLeft: 5,
          marginTop: 3
        }}
      />
    </div>
  );
};
export default PoweredByHumanitix;



// WEBPACK FOOTER //
// ./components/PoweredByHumanitix.js